import React, { ReactElement, useMemo } from 'react'
import styles from './BaseGuideComponent.module.scss'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import { jepAssertNever } from 'common/src/utils/jepAssertNever'

interface BaseGuideComponentProps {
    bulletSide: 'left' | 'right'
    bullets: ReactElement
    nonBullet: ReactElement
    shouldStackImagesAndBullets: boolean
}
export const BaseGuideComponent: React.FC<BaseGuideComponentProps> = (
    props
): ReactElement => {
    const components = useMemo((): {
        left: ReactElement
        right: ReactElement
    } => {
        if (props.shouldStackImagesAndBullets) {
            return { left: props.nonBullet, right: props.bullets }
        }
        switch (props.bulletSide) {
            case 'left':
                return { left: props.bullets, right: props.nonBullet }
            case 'right':
                return { left: props.nonBullet, right: props.bullets }
            default:
                return jepAssertNever(
                    props.bulletSide,
                    'Unhandled bulletSide for BaseGuideComponent'
                )
        }
    }, [
        props.bulletSide,
        props.bullets,
        props.nonBullet,
        props.shouldStackImagesAndBullets,
    ])

    return (
        <div className={styles.guideComponentContainer}>
            <div className={styles.widthLimitedContainer}>
                <div
                    className={`${styles.leftSide} ${reusableCssClass.centerChildrenVertically} ${styles.imageContainer}`}
                >
                    {components.left}
                </div>
                <div
                    className={`${styles.rightSide} ${reusableCssClass.centerChildrenVertically}  ${styles.imageContainer}`}
                >
                    {components.right}
                </div>
            </div>
        </div>
    )
}
